module.exports = __webpack_public_path__ + "static/img/background1.f8912680.png";